export default __webpack_public_path__ + "static/media/nolarge.5161b519.svg";